/**
 * Mobile Navigation Fix
 * Ensures mobile menu works even if custom elements fail to load
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  function initMobileNavFix() {
    // Find the menu button
    const menuButton = document.querySelector('.header__icon--menu.header__icon--summary');
    const menuDetails = document.querySelector('#Details-menu-drawer-container');
    const headerDrawer = document.querySelector('header-drawer');
    
    if (!menuButton || !menuDetails) {
      return;
    }

    // Ensure the button is clickable
    menuButton.style.pointerEvents = 'auto';
    menuButton.style.cursor = 'pointer';
    menuButton.style.zIndex = '101';
    
    // Remove any event listeners that might be blocking
    const newButton = menuButton.cloneNode(true);
    if (menuButton.parentNode) {
      menuButton.parentNode.replaceChild(newButton, menuButton);
    }
    
    // Add click handler as fallback
    newButton.addEventListener('click', function(e) {
      e.stopPropagation();
      e.preventDefault();
      
      const isOpen = menuDetails.hasAttribute('open');
      
      if (isOpen) {
        menuDetails.removeAttribute('open');
        document.body.classList.remove('overflow-hidden-tablet', 'overflow-hidden-mobile');
      } else {
        menuDetails.setAttribute('open', '');
        document.body.classList.add('overflow-hidden-tablet');
        
        // Set viewport height
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
        
        // Add menu-opening class after a short delay
        setTimeout(function() {
          menuDetails.classList.add('menu-opening');
        }, 10);
      }
      
      // Update aria-expanded
      const summary = newButton.querySelector('summary') || newButton;
      if (summary) {
        summary.setAttribute('aria-expanded', !isOpen);
      }
    }, true);
    
    // Also handle touch events for mobile
    newButton.addEventListener('touchend', function(e) {
      e.stopPropagation();
      e.preventDefault();
      newButton.click();
    }, { passive: false });
    
    // Ensure menu drawer is visible when open
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          const isOpen = menuDetails.hasAttribute('open');
          const menuDrawer = document.querySelector('#menu-drawer');
          
          if (isOpen && menuDrawer) {
            menuDrawer.style.transform = 'translateX(0)';
            menuDrawer.style.visibility = 'visible';
            menuDrawer.style.pointerEvents = 'auto';
          }
        }
      });
    });
    
    observer.observe(menuDetails, {
      attributes: true,
      attributeFilter: ['open']
    });
    
    // Fix menu items clickability
    const menuItems = document.querySelectorAll('.menu-drawer__menu-item');
    menuItems.forEach(function(item) {
      item.style.pointerEvents = 'auto';
      item.style.cursor = 'pointer';
      
      // Ensure links work
      const link = item.tagName === 'A' ? item : item.querySelector('a');
      if (link) {
        link.style.pointerEvents = 'auto';
        link.style.cursor = 'pointer';
      }
    });
    
    // Fix close button
    const closeButtons = document.querySelectorAll('.menu-drawer__close-button');
    closeButtons.forEach(function(button) {
      button.style.pointerEvents = 'auto';
      button.style.cursor = 'pointer';
      
      button.addEventListener('click', function(e) {
        e.stopPropagation();
        const details = button.closest('details');
        if (details) {
          details.removeAttribute('open');
        }
      });
    });
    
    // Handle window resize
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        if (menuDetails.hasAttribute('open')) {
          document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
        }
      }, 100);
    });
  }
  
  // Try multiple times to ensure it works
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileNavFix);
  } else {
    initMobileNavFix();
  }
  
  // Also try after a short delay in case custom elements load late
  setTimeout(initMobileNavFix, 100);
  setTimeout(initMobileNavFix, 500);
  setTimeout(initMobileNavFix, 1000);
})();

